/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyFollowUpQuestionnaire,
  PharmacyFollowUpQuestionnaireFromJSON,
  PharmacyFollowUpQuestionnaireFromJSONTyped,
  PharmacyFollowUpQuestionnaireToJSON,
} from "./";

export const PharmacyFollowUpQuestionnairePatternUpdatableTypename =
  "PharmacyFollowUpQuestionnairePatternUpdatable" as const;

/**
 *
 * @export
 * @interface PharmacyFollowUpQuestionnairePatternUpdatable
 */
export interface PharmacyFollowUpQuestionnairePatternUpdatable {
  /**
   *
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnairePatternUpdatable
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyFollowUpQuestionnairePatternUpdatable
   */
  orderNumber?: number;
  /**
   *
   * @type {Array<PharmacyFollowUpQuestionnaire>}
   * @memberof PharmacyFollowUpQuestionnairePatternUpdatable
   */
  questionnaires?: Array<PharmacyFollowUpQuestionnaire>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyFollowUpQuestionnairePatternUpdatable
   */
  readonly __typename?: string;
}

export function PharmacyFollowUpQuestionnairePatternUpdatableFromJSON(
  json: any
): PharmacyFollowUpQuestionnairePatternUpdatable {
  return PharmacyFollowUpQuestionnairePatternUpdatableFromJSONTyped(json, false);
}

export function PharmacyFollowUpQuestionnairePatternUpdatableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyFollowUpQuestionnairePatternUpdatable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyFollowUpQuestionnairePatternUpdatableTypename,

    name: !exists(json, "name") ? undefined : json["name"],
    orderNumber: !exists(json, "order_number") ? undefined : json["order_number"],
    questionnaires: !exists(json, "questionnaires")
      ? undefined
      : (json["questionnaires"] as Array<any>).map(PharmacyFollowUpQuestionnaireFromJSON),
  };
}

export function PharmacyFollowUpQuestionnairePatternUpdatableToJSON(
  object?: PharmacyFollowUpQuestionnairePatternUpdatable | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    name: value.name,
    order_number: value.orderNumber,
    questionnaires:
      value.questionnaires === undefined
        ? undefined
        : (value.questionnaires as Array<any>).map(PharmacyFollowUpQuestionnaireToJSON),
  };
}
